module.exports = __webpack_public_path__ + "2c672750d4d295a33e2c075b69d75e49.woff";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-light-webfont.woff
// module id = 341
// module chunks = 0